import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MsAdalAngular6Service } from 'microsoft-adal-angular6';
import { AuthenticationService } from './authentication.service';
import { ApiService } from 'src/app/api.service';
import { EnvService } from './env-service';

@Injectable()
export class AppConfigService {

    constructor(private http: HttpClient,
        private adalSvc: MsAdalAngular6Service,
        private authService: AuthenticationService,
        private apiService: ApiService, private env: EnvService) { }

    userApplications;
    load(): Promise<any> {
        this.userApplications = this.adalSvc.userInfo && this.adalSvc.userInfo.profile.given_name;
        if (this.userApplications && !this.authService.getUserApplications()) {
            var app = this.userApplications.split(";");
            var body = {
                active_directory_ids: app
            }
            const promise = this.http.post<any>(this.env.baseUrl + `insights/v1/applications/tenants`, body)
                .toPromise()
                .then(data => {
                    this.authService.updateUserApplications(data);
                    return data;
                });
            return promise;
        }
    }
}